'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Quotation = require('./Quotation');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Quotation).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Quotation/index.js
// module id = 1268
// module chunks = 1